import React from 'react'
import { connect } from 'react-redux'
import { localized, withPersistence } from 'decorators'
import { DeletedListPage } from 'components/page'
import { deletedListActionProps } from 'utils/gridActions'

const createDeletedListPage = ({ metadata, actionCreators, api, Content }) => {
  const CommonDeletedListPage = (props) => {
    const { [metadata.page]: data } = props
    return (
      <DeletedListPage metadata={metadata} emptyTrash={props.emptyTrash} data={data}>
        <Content
          key={props[metadata.page].gridKey}
          dataSource={api.getDeleted}
          metadata={metadata}
          persistor={props.persistor}
          isTrash
          actionProps={deletedListActionProps(props)} />
      </DeletedListPage>
    )
  }

  const mapDispatchToProps = {
    hardDelete: actionCreators.hardDelete,
    restore: actionCreators.restore,
    emptyTrash: actionCreators.emptyTrash
  }

  return connect(
    (state) => ({ [metadata.page]: state[metadata.page] }),
    mapDispatchToProps)(withPersistence(`page-trash:${metadata.page}`, localized(CommonDeletedListPage)))
}

export {
  createDeletedListPage
}
